// extracted by mini-css-extract-plugin
export default {"appInstallBtn":"AppInstallBtn_appInstallBtn__Ae5B8","progressWrapper":"AppInstallBtn_progressWrapper__60act","ctaBtn":"AppInstallBtn_ctaBtn__XIsBQ"};